var _g, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "New_task_status",
    "data-name": "New task status",
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 22,
    viewBox: "0 0 38 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_278",
    "data-name": "Rectangle 278",
    fill: "none",
    stroke: "#70C382",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 22,
    rx: 4.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 38,
    height: 22,
    rx: 4,
    fill: "none"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "New",
    transform: "translate(5 16)",
    fill: "#397C67",
    stroke: "#397C67",
    strokeWidth: 0.3,
    fontSize: 12,
    letterSpacing: 0,
    fontFamily: "Lato-Regular, Lato"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "NEW"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewTag);
export default __webpack_public_path__ + "static/media/new_tag.b2513353dcbcd62ed123d671cc52b255.svg";
export { ForwardRef as ReactComponent };